import script from "./MainContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainContent.vue?vue&type=script&lang=ts&setup=true"

import "./MainContent.vue?vue&type=style&index=0&id=58500038&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58500038"]])

export default __exports__